import React from 'react'
import { useIntl } from 'react-intl'

function TableHeader({ headers }) {
  const { locale } = useIntl()
  return (
    <div
      dir={locale === 'ar' ? 'rtl' : 'ltr'}
      class='tw-px-[10px] tw-hidden md:tw-flex tw-border-b-[1px] tw-border-[#E7E7E7] tw-pb-[10px]'
    >
      {headers.map((header) => (
        <div
          style={{
            width: (2 / headers.length) * 100 + '%',
            minWidth: '100px',
          }}
          class='tw-text-[12px] tw-flex tw-gap-[3px] tw-cursor-pointer'
        >
          {header}
        </div>
      ))}
    </div>
  )
}

export default TableHeader
